import { CheckIcon, ErrorIcon } from 'internalLibrary';
import classes from 'classnames';
import React from 'react';
import styles from './Stepper.module.scss';

export type Step = {
  text: string;
  error?: boolean;
};

export type Props = {
  steps: Array<Step>;
  currentStep: number;
  currentStepFinished?: boolean;
  className?: string;
  dataTest?: string;
};

export const Stepper: React.FC<Props> = ({
  steps,
  currentStep,
  currentStepFinished,
  className,
  dataTest,
}) => {
  return (
    <div data-test={dataTest} className={className}>
      {steps.map((step, index) => {
        const isCurrentStep = currentStep === index;
        const isCompletedStep =
          currentStep > index || (isCurrentStep && currentStepFinished);
        const isError = step.error;

        const errorIcon = isError && <ErrorIcon />;
        const completedStepIcon = isCompletedStep && <CheckIcon />;

        const icon = errorIcon || completedStepIcon;

        return (
          <div
            className={classes(
              styles.step,
              isCompletedStep && styles.completed,
              isCurrentStep && styles.active,
              isError && styles.error,
            )}
            key={index}
          >
            <div data-test={`circle-${index}`} className={styles.circle}>
              {icon}
            </div>
            <span data-test={`label-${index}`} className={styles.label}>
              {step.text}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
